export default {
    namespaced: true,
    state: {
        company: {},
        person: {},
        requestors: [],
        products: [],
        candidateUser: {},
        job: {},
        jobs: {
            results: [],
            count: 0
        },
        allJobs: [],
        candidateUsers: {
            results: [],
            count: 0
        },
        casualMeetingUsers: {
            results: [],
            count: 0
        },
        payments: [],
        images: []
    },
    getters: {
        company(state) {
            return state.company
        },
        person(state) {
            return state.person
        },
        requestors(state) {
            return state.requestors
        },
        products(state) {
            return state.products;
        },
        job(state) {
            return state.job;
        },
        jobs(state) {
            return state.jobs;
        },
        allJobs(state) {
            return state.allJobs
        },
        candidateUsers(state) {
            return state.candidateUsers;
        },
        casualMeetingUsers(state) {
            return state.casualMeetingUsers;
        },
        candidateUser(state) {
            return state.candidateUser;
        },
        payments(state) {
            return state.payments;
        },
        images(state) {
            return state.images;
        }
    },
    mutations: {
        setBusiness(state, payload) {
            state.person = payload.business;
        },
        setCompany(state, payload) {
            state.company = payload.company;
        },
        setCompanyLogo(state, payload) {
            state.company = {...state.company, logoUrl: payload.logoUrl}
        },
        setCandidateUser(state, payload) {
            state.candidateUser = payload.user;
        },
        setJobs(state, payload) {
            state.jobs = payload.jobs;
        },
        setAllJobs(state, payload) {
            state.allJobs = payload.jobs;
        },
        setJob(state, payload) {
            state.job = payload.job;
        },
        setProducts(state, payload) {
            state.products = payload.products;
        },
        setCandidateUsers(state, payload) {
            state.candidateUsers = payload.candidateUsers;
        },
        setCasualMeetingUsers(state, payload) {
            state.casualMeetingUsers = payload.casualMeetingUsers;
        },
        setPayments(state, payload) {
            state.payments = payload.payments
        },
        setClientImages(state, payload) {
            state.images = payload.images;
        },
        addClientImage(state, payload) {
            state.images.unshift(payload.image);
        },
        removeClientImage(state, payload) {
            state.images = state.images.filter(image => image.id !== payload.id);
        },
        setUsedMf(state, payload) {
            state.company = {
                ...state.company,
                usedMf: payload.usedMf
            }
        },
        setRequestors(state, {requestors}) {
            state.requestors = requestors
        },
        setRequestor(state, {requestor}) {
            if (state.requestors.map(requestor => requestor.id).includes(requestor.id)) {
                state.requestors = state.requestors.map(item => {
                    if (item.id === requestor.id) {
                        return requestor
                    }
                    return item
                })
            } else {
                state.requestors.unshift(requestor)
            }
        },
        setRequestorImage(state, {requestorId, imageUrl}) {
            state.requestors = state.requestors.map(item => {
                if (item.id === requestorId) {
                    return {...item, imageUrl}
                }
                return item
            })
        },
        deleteRequestor(state, {requestorId}) {
            state.requestors = state.requestors.filter(item => item.id !== requestorId)
        },
        setCandidateUserMemo(state, {memo, userId}) {
            state.candidateUsers.results = state.candidateUsers.results.map(user => {
                if (user.id === userId) {
                    return { ...user, memo }
                }
                return user
            })
        }
    },
    actions: {
        updateBusiness({commit}, {business}) {
            commit("setBusiness", {business: business})
        },
        updateCompany({commit}, {company}) {
            commit("setCompany", {company: company})
        },
        updateCompanyLogo({commit}, {logoUrl}) {
            commit("setCompanyLogo", {logoUrl: logoUrl})
        },
        updateUser({commit}, {user}) {
            commit("mergeUser", {user: user})
        },
        updateCandidateUser({commit}, {user}) {
            commit("setCandidateUser", {user: user})
        },
        updateJobs({commit}, {jobs}) {
            commit("setJobs", {jobs: jobs});
        },
        updateAllJobs({commit}, {jobs}) {
            commit("setAllJobs", {jobs: jobs});
        },
        updateJob({commit}, {job}) {
            commit("setJob", {job: job});
        },
        updateProducts({commit}, {products}) {
            commit("setProducts", {products: products});
        },
        updateCandidateUsers({commit}, {candidateUsers}) {
            commit("setCandidateUsers", {candidateUsers: candidateUsers});
        },
        updateCasualMeetingUsers({commit}, {casualMeetingUsers}) {
            commit("setCasualMeetingUsers", {casualMeetingUsers: casualMeetingUsers});
        },
        updatePayments({commit}, {payments}) {
            commit("setPayments", {payments: payments})
        },
        updateImages({commit}, {images}) {
            commit('setClientImages', {images: images});
        },
        addImage({commit}, {image}) {
            commit("addClientImage", {image: image});
        },
        removeImage({commit}, {id}) {
            commit("removeClientImage", {id: id});
        },
        updateUsedMf({commit}, {usedMf}) {
            commit("setUsedMf", {usedMf: usedMf});
        },
        updateRequestors({commit}, {requestors}) {
            commit("setRequestors", {requestors})
        },
        updateRequestor({commit}, {requestor}) {
            commit("setRequestor", {requestor})
        },
        deleteRequestor({commit}, {requestorId}) {
            commit("deleteRequestor", {requestorId})
        },
        updateRequestorImage({commit}, {requestorId, imageUrl}) {
            commit("setRequestorImage", {requestorId, imageUrl})
        },
        updateCandidateUserMemo({commit}, {memo, userId}) {
            commit("setCandidateUserMemo", {memo, userId})
        }
    }
}
